import { render } from "./DetalhesPlano.vue?vue&type=template&id=55b32c44&scoped=true"
import script from "./DetalhesPlano.vue?vue&type=script&lang=js"
export * from "./DetalhesPlano.vue?vue&type=script&lang=js"

import "./DetalhesPlano.vue?vue&type=style&index=0&id=55b32c44&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b32c44"]])

export default __exports__